import React, { useEffect, useMemo } from 'react'
import { connect } from 'react-redux'

import { completeAnimatingIn, completeAnimatingOut, completePreloading } from '../../reducers/nav'

const IndexWrapper = ({ dispatch, navState, componentName, children }) => {
    const componentState = useMemo(() => {
        if (navState.activeComponent === componentName) {
            return 'ACTIVE'
        } else if (navState.preLoadingComponent === componentName) {
            return 'PRELOADING'
        } else if (navState.animatingInComponent === componentName) {
            return 'ANIMATING_IN'
        } else if (navState.animatingOutComponent === componentName) {
            return 'ANIMATING_OUT'
        }
        return 'OFF'
    }, [navState, componentName])

    useEffect(() => {
        if (componentState === 'PRELOADING') {
            setTimeout(() => {
                dispatch(completePreloading())
            }, 1000)
        } else if (componentState === 'ANIMATING_IN') {
            setTimeout(() => {
                dispatch(completeAnimatingIn())
            }, 1000)
        } else if (componentState === 'ANIMATING_OUT') {
            setTimeout(() => {
                dispatch(completeAnimatingOut())
            }, 1000)
        }
    }, [componentState, dispatch])

    // should we render this component?
    if (componentState === 'OFF') {
        return null
    }

    return (
        <>
            {/* <p>State: {componentState}</p> */}
            {React.cloneElement(children, { componentState })}
        </>
    )
}

export default connect()(IndexWrapper)
